import { render, staticRenderFns } from "./SysMenuItem.vue?vue&type=template&id=238fc776"
import script from "./SysMenuItem.vue?vue&type=script&lang=js"
export * from "./SysMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports